export const INTERVAL_DEFAULT = 300

export const TIMEOUT_DEFAULT = 30000

export const MODE_DEFAULT = "async"

export const SCOPE_DEFAULT = "body"
